import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CaptureDrawer } from "../components/CaptureDrawer";
import type { CaptureSummary } from "../lib/api-types";
import type { Vault } from "../contexts/vault-types";

export default function TagFilter() {
  const { vault, tag } = useParams() as { vault: Vault; tag: string };
  const navigate = useNavigate();
  const [items, setItems] = useState<CaptureSummary[]>([]);
  const [drawer, setDrawer] = useState<{ vault: Vault; slug: string } | null>(null);

  useEffect(() => {
    fetch(`/api/captures?vault=${vault}&tag=${tag}&limit=100`)
      .then(r => r.ok ? r.json() : Promise.resolve([]))
      .then(setItems);
  }, [vault, tag]);

  return (
    <div className="min-h-screen px-4 pt-3 pb-4">
      <button onClick={() => navigate(-1)} className="text-attic-accent text-sm mb-2">‹ Back</button>
      <div className="flex items-center gap-2 mb-2">
        <span className="bg-attic-accent-bg text-attic-accent font-bold rounded-full px-3 py-1">#{tag}</span>
      </div>
      <p className="text-attic-dim text-xs mb-4">{items.length} captures in {vault}</p>
      {items.map(item => (
        <div
          key={item.id}
          className="flex bg-attic-surface border border-attic-border rounded-xl mb-2 overflow-hidden"
        >
          <button
            onClick={() => setDrawer({ vault, slug: item.id })}
            className="flex-1 text-left p-3"
          >
            <h4 className="text-sm font-semibold">{item.title}</h4>
            <p className="text-[10px] text-attic-dim">{item.source} · {item.capturedAt.slice(0, 10)}</p>
            <p className="text-xs text-attic-dim mt-1 leading-relaxed">{item.summary}</p>
          </button>
          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="text-attic-accent text-lg font-semibold px-3 flex items-center"
              aria-label="View original"
            >
              ↗
            </a>
          )}
        </div>
      ))}
      {drawer && <CaptureDrawer vault={drawer.vault} slug={drawer.slug} onClose={() => setDrawer(null)} />}
    </div>
  );
}
